import React, { useEffect, useState } from "react";
import Header from "../../../../CommonComponents/header";
import { Footer } from "../../../../CommonComponents/footer";
import { baseurl } from "../../../../CommonComponents/baseurl";
import { useParams } from "react-router-dom";
import { Img } from "../../../../subComponents/img";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { MobileHeader } from "../../../../CommonComponents/mobileHeader";
import { MainHeading } from "../../../../subComponents/MainHeading";

const RecentProject = () => {
  const [currentproject, setCurrentProject] = useState(null);
  const { slug } = useParams();

  useEffect(() => {
    const fetchrecentProject = async () => {
      const formData = new FormData();
      formData.append("slug", slug);

      try {
        const response = await fetch(`${baseurl}/api/project-details`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        if (data.success === "1") {
          setCurrentProject(data.data);
        } else {
          console.error("Failed to recent project data:", data.message);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchrecentProject();
  }, [slug]);

  useEffect(() => {
    console.log("currentproject:", currentproject);
  }, [currentproject]);

  return (
    <>
      <Header />
      <MobileHeader />
      <div className="desktop_header_spacer"></div>
      {currentproject === null ? (
        <Box sx={{ display: "flex" }}>
          <CircularProgress style={{ color: "#000", margin: "auto" }} />
        </Box>
      ) : (
        <section className="recent_project_hero_section">
          <Img
            src={currentproject.image2}
            alt={currentproject.image2}
            style={{ objectFit: "cover" }}
            height={"100%"}
            width={"100%"}
          />

          <div className="commercial_description">
            <br />
            <MainHeading title={currentproject.title} />
            <br />
            <p
              dangerouslySetInnerHTML={{ __html: currentproject.description }}
            ></p>
          </div>
        </section>
      )}

      <Footer />
    </>
  );
};
export default RecentProject;
